export default {
	install(Vue, options) {}
}

// 读取所有md文档
var docs = require.context("../../public/doc", true, /\.md$/)
var components = {}
for (var doc of docs.keys()) {
	var name = doc.split("/")[1].split(".")[0]
	components[name] = docs(doc).default
}

export var components = components
